import axiosInstance from "./axiosInstance";

const ClientService = {

    updateLogo: async(formData)  => {
        const response = await axiosInstance.post("/api/clients/updateLogo", formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
        return response.data;
    }
}

export default ClientService;